var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { Modal as ArcoModal } from '@arco-design/web-react';
import ConfigProvider, { getGlobalContext } from '@m4b-design/config-provider';
import React from 'react';
import { normalizeConfig } from './utils';
import './style/confirm.less';
function confirm(config) {
  var globalContext = getGlobalContext();
  var _a = ArcoModal.confirm(__assign(__assign({}, normalizeConfig(config)), {
      // TODO: 如果有不适合透传的情况，需要在这里过滤。（目前还没有这种case）
      content: /*#__PURE__*/React.createElement(ConfigProvider, __assign({}, globalContext), config.content)
    })),
    rawUpdate = _a.update,
    close = _a.close;
  var update = function update(newConfig) {
    var newGlobalContext = getGlobalContext(); // 要忽略config中的onOk，因为arco只会在Modal.confirm中对传入的onOk进行一层包装，使得调用onOk可以自动关闭弹窗
    // 在update中传入onOk，调用onOk后不会关闭弹窗
    // 复现例子：https://codesandbox.io/s/charming-fast-t33jcz?file=/demo.js
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var onOk = config.onOk,
      restConfig = __rest(config, ["onOk"]); // 用户调用update的场景一般是用于更新content，其他内容不变，所以newConfig中一般只有content
    // 需要和confirm方法传入的config做一次合并，否则经过normalizeConfig方法，className、title、footer等会不符合预期
    // 不合并，已知会出现以下问题：
    // title会变为null
    // 原来footer为null，在content自己实现的footer，经过normalizeConfig，会额外增加1个footer
    var mergerdConfig = __assign(__assign({}, restConfig), newConfig);
    return rawUpdate(__assign(__assign({}, normalizeConfig(mergerdConfig)), {
      content: /*#__PURE__*/React.createElement(ConfigProvider, __assign({}, newGlobalContext), mergerdConfig.content)
    }));
  };
  return {
    update: update,
    close: close
  };
}
export default confirm;